module.exports = [{"label":"DHL","value":"dhl"},{"label":"DPD","value":"dpd"}]


//////////////////
// WEBPACK FOOTER
// ./src/db/versandCarrier.json
// module id = 623
// module chunks = 0